module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thankyou-wrapper animate fadeIn"
  }, [(_vm.invoice && !_vm.loading) ? _c(_vm.template, _vm._b({
    tag: "component"
  }, 'component', _vm.props, false)) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296633de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThankYou.vue
// module id = 707
// module chunks = 1